// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_js-0";